(function() {
  'use strict';

  angular
    .module('newscombinatorKeywords', ['ngAnimate', 'ngCookies', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ngMaterial','nvd3']);

})();

(function () {
    'use strict';

    angular
        .module('newscombinatorKeywords')
        .factory('SolrRequest', solrRequestFactory);

    /** @ngInject */
    function solrRequestFactory($http) {
        function SolrRequest() {

            this.start = 0;
            this.siteState = {loading: false};
            this.expanded = {};
            this.numFound = 0;
            this.maxScore = 0;

            this.news = [];
            this.results = [];
            this.documentIds = [];
            this.facets = {};

            this.solrQuery = new SolrQuery();

        }

        SolrRequest.prototype.setQuery = function (solrQuery) {
            if (!(solrQuery instanceof SolrQuery)) {
                throw "SolrRequest needs a SolrQuery!";
            }

            this.solrQuery = solrQuery;

        };


        SolrRequest.prototype.getLoading = function () {
            return this.siteState.loading;
        };

        SolrRequest.prototype.moreToLoad = function () {
            return this.numFound > this.results.length;
        };

        SolrRequest.prototype.getExpanded = function () {
            return this.expanded;
        };

        SolrRequest.prototype.loadNews = function () {
            var self = this;
            if (this.siteState.loading !== true) {
                this.siteState.loading = true;

                return $http({
                    method: 'GET',
                    url: "http://www.newscombinator.com/api/statistics",
                    params: this.solrQuery.getHttpRequestParamObject()
                }).then(function (result) {

                    self.results = result.data.response.docs;
                    for (var i = 0; i < self.results.length; i++) {
                        self.documentIds.push(self.results[i].id);
                    }
                    self.expanded = result.data.expanded || {};
                    self.facets = result.data.facets || {};
                    self.start = result.data.response.docs.length;
                    self.numFound = result.data.response.numFound;
                    self.maxScore = result.data.response.maxScore;
                    self.siteState.loading = false;
                }, function (errorResponse) {
                    console.error(errorResponse);
                    self.siteState.loading = false;
                });
            }
        };

        SolrRequest.prototype.getResults = function () {
            return this.results;
        };
        SolrRequest.prototype.getFacets = function () {
            return this.facets;
        };

        SolrRequest.prototype.nextPage = function () {
            var self = this;
            if (this.siteState.loading !== true && this.start > 0 && this.documentIds.length < this.numFound) {
                this.siteState.loading = true;

                var params = QueryService.getHttpRequestParamObject();
                params.start = this.start;
                $http({
                    method: 'GET',
                    url: ENV.searchEndpoint + 'search/',
                    params: params
                }).then(function (result) {
                    var items = result.data.response.docs;
                    for (var i = 0; i < items.length; i++) {
                        if (self.documentIds.indexOf(items[i].id) === -1) {
                            this.results.push(items[i]);
                            self.documentIds.push(items[i].id);
                        }
                    }
                    //angular.extend(this.results, response.response.docs);
                    angular.extend(this.expanded, result.data.expanded);
                    angular.extend(this.facets, result.data.facets);
                    self.start = this.results.length;
                    self.siteState.loading = false;

                }, function (errorResponse) {
                    console.error(errorResponse);
                    self.siteState.loading = false;
                });
            }
        };

        SolrRequest.prototype.reset = function () {
            this.start = 0;
            this.siteState = {loading: false};
            this.expanded = {};
            this.numFound = 0;
            this.maxScore = 0;

            this.news = [];
            this.results = [];
            this.documentIds = [];
        };

        return {
            Instance: SolrRequest
        }
    }
})();
/**
 * Created by Thomas on 01.04.2016.
 */

'use strict';

function SolrQuery() {
    this.importancy = {
        'points': 2.5,
        'age': 2.5
    };
    this.filterQuery = [];
    this.facetQuery = {};
    this.fromDate = null;
    this.toDate = null;

    this.keywords = '';
    this.rows = 10;

}

SolrQuery.prototype.setRows = function (rows) {
    this.rows = rows;
};

SolrQuery.prototype.setFilterQuery = function (name, filterQuery) {
    this.filterQueries[name] = filterQuery;
};

SolrQuery.prototype.getFilterQueries = function () {
    return this.filterQueries
};

SolrQuery.prototype.getRows = function () {
    return this.rows;
};


SolrQuery.prototype.getHttpRequestParamObject = function () {
    var objParams = {
        'q': this.getQueryString(),
        'rows': this.rows
    };

    objParams = this.getFilterQueryObject(objParams);

    if (this.facetQuery !== {}) {
        objParams.facetting = this.getFacetQueryJson();
    }
    return objParams;
};

SolrQuery.prototype.getQueryString = function () {
    var queryString = '';
    if (this.importancy.points !== 0 || this.importancy.age !== 0) {
        queryString += '( ';
        if (this.importancy.points > 0) {
            queryString += '_val_:"log(add(1,num_total_points))"^' + this.importancy.points * 3 + ' ';
        }

        if (this.importancy.age > 0) {
            queryString += '_val_:"recip(ms(NOW/HOUR,created_at),3.16e-11,2700,1)"^' + this.importancy.age + ' ';
        }

        queryString += ' )';

    }


    if (this.keywords.length > 0) {
        queryString += ' ' + this.keywords + ' ';
    }

    return queryString;
};


SolrQuery.prototype.getFilterQueryObject = function (objParams) {

    var filterQueryObject = objParams || {};
    var filterQueryKeyInt = 0;
    for (var i = 0; i < this.filterQuery.length; i++) {
        filterQueryObject['fq[' + filterQueryKeyInt + ']'] = this.filterQuery[i];
        filterQueryKeyInt++;
    }

    if (this.fromDate instanceof Date || this.toDate instanceof Date) {
        var queryString = 'created_at:[';
        if (this.fromDate instanceof Date) {
            queryString += this.fromDate.toISOString();
        } else {
            queryString += '*';
        }
        queryString += ' TO ';

        if (this.toDate instanceof Date) {
            queryString += this.toDate.toISOString();
        } else {
            queryString += '*';
        }
        queryString += ']';

        filterQueryObject['fq[' + filterQueryKeyInt + ']'] = queryString;
        filterQueryKeyInt++;
    }

    return filterQueryObject;
};

SolrQuery.prototype.solrEscape = function (inputValue) {
    var match = ['\\', '+', '-', '&', '|', '!', '(', ')', '{', '}', '[', ']', '^', '~', '*', '?', ':', '"', ';', ' '];
    var replace = ['\\\\', '\\+', '\\-', '\\&', '\\|', '\\!', '\\(', '\\)', '\\{', '\\}', '\\[', '\\]', '\\^', '\\~', '\\*', '\\?', '\\:', '\\"', '\\;', '\\ '];

    for (var i = 0; i < match.length; i++) {
        inputValue = inputValue.replace(match[i], replace[i]);
    }

    return inputValue;

};

SolrQuery.prototype.setFilterQueryFromArray = function (arrayValues) {

    var query1 = this;
    var query_reset = false;
    angular.forEach(arrayValues, function (value) {
        if (value.keyword == "") {
            return;
        }

        if(!query_reset) {
            query1.keywords = "";
            query_reset = true;
        }
        if (value.type.type == 'text') {
            query1.addFilterQuery(value.type.prefix + query1.solrEscape(value.keyword) + value.type.postfix);
            query1.keywords += value.type.prefix + query1.solrEscape(value.keyword) + value.type.postfix + " ";
        } else if (value.type.type == 'datepicker') {
            query1.addFilterQuery(value.type.prefix + value.date.toISOString() + value.type.postfix);
            query1.keywords += value.type.prefix + value.date.toISOString() + value.type.postfix + " ";
        } else if (value.type.type == 'slider') {
            query1.addFilterQuery(value.type.prefix + value.keyword + value.type.postfix);
            query1.keywords += value.type.prefix + value.keyword + value.type.postfix + " ";
        } else if (value.type.type == 'select') {
            query1.addFilterQuery(value.type.prefix + value.keyword + value.type.postfix);
            query1.keywords += value.type.prefix + value.keyword + value.type.postfix + " ";
        }

        if (value.type.override !== undefined) {
            vm[value.type.override] = value.keyword;
        }
    });
};


SolrQuery.prototype.addFilterQuery = function (filter) {
    //do nothing if entity is already in the list
    for (var i = 0; i < this.filterQuery.length; i++) {
        if (this.filterQuery[i] == filter) {
            return false;
        }
    }

    this.filterQuery.push(filter);
    return true;
};

SolrQuery.prototype.getFacetQueryJson = function () {
    return JSON.stringify(this.facetQuery);
};

SolrQuery.prototype.addFacetTerms = function (name, field, limit, mincount, parent, domain, sort) {

    var facetQuery = {};
    facetQuery.type = "terms";
    facetQuery.field = field;
    if (limit !== undefined && limit >= 0) {
        facetQuery.limit = limit;
    }
    if (mincount !== undefined && mincount >= 0) {
        facetQuery.mincount = mincount;
    }
    if (domain !== undefined) {
        facetQuery.domain = domain;
    }
    if (sort !== undefined) {
        facetQuery.sort = sort;
    }

    if (parent !== undefined && this.facetQuery[parent] !== undefined) {
        if (this.facetQuery[parent].facet == undefined) {
            this.facetQuery[parent].facet = {};
        }
        this.facetQuery[parent]["facet"][name] = facetQuery;
    } else {
        this.facetQuery[name] = facetQuery;
    }
};

SolrQuery.prototype.addFacetRange = function (name, field, start, end, gap, limit, mincount, parent) {

    var facetQuery = {};
    facetQuery.type = "range";
    facetQuery.field = field;
    facetQuery.start = start;
    facetQuery.end = end;
    facetQuery.gap = gap;
    if (limit !== undefined && limit >= 0) {
        facetQuery.limit = limit;
    }
    if (mincount !== undefined && mincount >= 0) {
        facetQuery.mincount = mincount;
    }

    if (parent !== undefined && this.facetQuery[parent] !== undefined) {
        this.facetQuery[parent]["facet"][name] = facetQuery;
    } else {
        this.facetQuery[name] = facetQuery;
    }
};
SolrQuery.prototype.addFacetFunction = function (fieldName, functionName, parent) {
    if (parent !== undefined && this.facetQuery[parent] !== undefined) {
        this.facetQuery[parent]["facet"][fieldName] = functionName;
    }
};

SolrQuery.prototype.removeFilterQueryByIndex = function (index) {
    if (this.filterQuery[index] !== undefined) {
        this.filterQuery.splice(index, 1);
    }
};

SolrQuery.prototype.getFilterQueryIndexFromString = function (string) {
    for (var i = 0; i < this.filterQuery.length; i++) {
        if (this.filterQuery[i] === string) {
            return i;
        }
    }
};

SolrQuery.prototype.setKeywords = function (keywords) {
    if (keywords === undefined || keywords.length <= 0) {
        this.keywords = "*:*"
    } else {
        this.keywords = keywords;
    }
};
SolrQuery.prototype.getImportancy = function () {
    return this.importancy;
};


SolrQuery.prototype.resetQuery = function () {

    this.importancy = {
        'points': 2.5,
        'age': 2.5
    };
    this.filterQuery = [];
    this.fromDate = null;
    this.toDate = null;

    this.keywords = '';
    this.rows = 10;

};



(function() {
  'use strict';

  angular
    .module('newscombinatorKeywords')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController() {

    }
  }

})();

(function () {
    'use strict';

    angular
        .module('newscombinatorKeywords')
        .directive('keywordsTable', dateChart);

    /** @ngInject */
    function dateChart(SolrRequest) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/keywordstable/keywordstable.html',
            scope: {
                data: '='
            },
            controller: ChartController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ChartController($scope, $filter, $timeout) {

            var vm = this;
            vm.chartoptions = {
                chart: {
                    type: 'pieChart',
                    height: 150,
                    width: 150,
                    x: function (d) {
                        return d.key;
                    },
                    y: function (d) {
                        return d.y;
                    },
                    showLabels: false,
                    duration: 1000,
                    labelThreshold: 1,
                    labelSunbeamLayout: true,
                    showLegend: false
                }

            };

            vm.keywordsdata = [];

            vm.addKeyword = function (word) {

                vm.data.keywords.push({
                    type: $filter("filter")(vm.data.keywordTypes, {typeValue: 'general'})[0],
                    keyword: word
                });

                //$scope.$apply();
                vm.loadChart();
            };

            vm.loadChart = function () {

                vm.loading = true;
                var query1 = new SolrQuery();
                query1.setKeywords("*:*");
                query1.getImportancy().points = 5;
                query1.getImportancy().age = 0;
                query1.addFilterQuery("content_type:document");
                query1.addFilterQuery("on_frontpage:1");
                query1.setFilterQueryFromArray(vm.data.keywords);

                query1.setRows(20);
                query1.addFacetTerms("keywords", "title_terms", 30, 1);
                query1.addFacetTerms("frontpage", "on_frontpage", 2, 0, "keywords", {blockParent: "content_type:sourceitem"});

                var solrReq_1 = new SolrRequest.Instance();
                solrReq_1.setQuery(query1);
                solrReq_1.loadNews().then(function () {

                    vm.loading = false;
                    vm.topResults = solrReq_1.getResults();
                    vm.keywordsdata = [];
                    if (solrReq_1.getFacets().count > 0) {

                        angular.forEach(solrReq_1.getFacets()["keywords"]["buckets"], function (value) {
                            var chardata = [];
                            angular.forEach(value.frontpage.buckets, function (val_frontpage) {
                                if (val_frontpage.val == false) {
                                    chardata.push({key: "Not on Frontpage", y: val_frontpage.count});
                                } else {
                                    chardata.push({key: "On Frontpage", y: val_frontpage.count});
                                }
                            });
                            vm.keywordsdata.push({keyword: value, chartdata: chardata});

                        });

                    }
                });

                query1 = new SolrQuery();
                query1.setKeywords("*:*");
                query1.getImportancy().points = 5;
                query1.getImportancy().age = 0;
                query1.addFilterQuery("on_frontpage:0");
                query1.setFilterQueryFromArray(vm.data.keywords);

                query1.setRows(20);
                query1.addFacetTerms("keywords", "title_terms", 30, 1);
                query1.addFacetTerms("frontpage", "on_frontpage", 2, 0, "keywords", {blockParent: "content_type:sourceitem"});

                var solrReq_2 = new SolrRequest.Instance();
                solrReq_2.setQuery(query1);
                solrReq_2.loadNews().then(function () {

                    vm.topResults_non_fp = solrReq_2.getResults();
                    vm.keywordsdata_non_fp = [];
                    if (solrReq_2.getFacets().count > 0) {

                        angular.forEach(solrReq_2.getFacets()["keywords"]["buckets"], function (value) {
                            var chardata = [];
                            angular.forEach(value.frontpage.buckets, function (val_frontpage) {
                                if (val_frontpage.val == false) {
                                    chardata.push({key: "Not on Frontpage", y: val_frontpage.count});
                                } else {
                                    chardata.push({key: "On Frontpage", y: val_frontpage.count});
                                }
                            });
                            vm.keywordsdata_non_fp.push({keyword: value, chartdata: chardata});

                        });

                    }
                });
            };

            var loadChartTimeout;

            function loadChartDelayed() {

                vm.loading = true;
                if (loadChartTimeout !== undefined) {
                    $timeout.cancel(loadChartTimeout);
                }
                loadChartTimeout = $timeout(vm.loadChart, 1500);
            }

            $scope.$watch("vm.data", loadChartDelayed, true);
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('newscombinatorKeywords')
        .directive('weekdayChart', weekdayChart);

    /** @ngInject */
    function weekdayChart(SolrRequest) {
        var directive = {
            restrict: 'E',
            template: '<nvd3 options="vm.options" data="vm.chartdata"></nvd3>',
            scope: {
                data: '='
            },
            controller: ChartController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ChartController($scope, $filter, $timeout) {

            var vm = this;

            var dayNameToInt = {
                'Monday': 0,
                'Tuesday': 1,
                'Wednesday': 2,
                'Thursday': 3,
                'Friday': 4,
                'Saturday': 5,
                'Sunday': 6
            };
            var intDayToStringDay = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

            vm.addKeyword = function(objKeyword) {
                this.data.keywords.push(objKeyword);
            };

            vm.options = {
                chart: {
                    type: 'multiBarChart',
                    height: 500,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 50,
                        left: 70
                    },
                    x: function (d) {
                        return d[0];
                    },
                    y: function (d) {
                        return d[1];
                    },
                    multibar: {
                        dispatch: {
                            elementClick: function (e) {
                                vm.data.keywords.push({
                                    type: $filter("filter")(vm.data.keywordTypes, {typeValue: 'found_weekdays_ss'})[0],
                                    keyword: intDayToStringDay[e.data[0]]
                                });
                                $scope.$apply();
                                vm.loadChart();
                            }

                        }
                    },
                    duration: 1000,
                    useInteractiveGuideline: true,
                    xAxis: {
                        tickValues: [0, 1, 2, 3, 4, 5, 6],
                        tickFormat: function (d) {
                            return intDayToStringDay[d];
                        },
                        axisLabel: 'Days of the Week'
                    },
                    yAxis: {
                        tickFormat: function (d) {
                            return d3.format('s')(d);
                        },
                        axisLabel: 'Number of Documents'
                    },
                    sortDescending: false
                },
                title: {
                    enable: true,
                    text: 'Weekday Chart'
                },
                subtitle: {
                    enable: true,
                    text: 'This charts shows on which weekday how many submitted links were upvotes until the frontpage and how many never made it there. It is sorted from the highest amount per weekday to the lowest. Sidenote: If you select documents which are posted on e.g. Monday, then you can see when the documents have been crossposted as well.',
                    css: {
                        'text-align': 'center',
                        'margin': '10px 13px 0px 7px',
                        'font-size': '80%'
                    }
                }
            };

            vm.chartdata = [{values: [], key: 'On Frontpage'}, {values: [], key: 'Not On Frontpage'}];

            vm.loadChart = function () {

                var query1 = new SolrQuery();
                query1.setKeywords("*:*");
                query1.getImportancy().points = 0;
                query1.getImportancy().age = 0;
                query1.addFilterQuery("content_type:document");
                query1.setFilterQueryFromArray(vm.data.keywords);

                query1.addFacetTerms("day_of_the_week", "found_weekdays_ss", 7, 1, undefined, undefined, {count:"desc"});
                query1.addFacetTerms("frontpage", "on_frontpage", 2, 0, "day_of_the_week", {blockParent: "content_type:sourceitem"});
                var solrReq_1 = new SolrRequest.Instance();
                solrReq_1.setQuery(query1);
                solrReq_1.loadNews().then(function () {

                    vm.chartdata[0].values = [];
                    vm.chartdata[1].values = [];
                    if (solrReq_1.getFacets().count > 0) {
                        angular.forEach(solrReq_1.getFacets()["day_of_the_week"]["buckets"], function (value, key) {
                            if (value.frontpage !== undefined) {
                                angular.forEach(value.frontpage.buckets, function (value_fp) {
                                    if (value_fp.val === true) {
                                        vm.chartdata[0].values.push([dayNameToInt[value.val], value_fp.count]);
                                    } else {
                                        vm.chartdata[1].values.push([dayNameToInt[value.val], value_fp.count]);
                                    }
                                });
                            } else {
                                vm.chartdata[0].values.push([dayNameToInt[value.val], null]);
                                vm.chartdata[1].values.push([dayNameToInt[value.val], null]);
                            }
                        });

                    }
                });
            };
            var loadChartTimeout;

            function loadChartDelayed() {
                if(loadChartTimeout !== undefined) {
                    $timeout.cancel(loadChartTimeout);
                }
                loadChartTimeout = $timeout(vm.loadChart, 550);
            }

            $scope.$watch("vm.data", loadChartDelayed, true);

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('newscombinatorKeywords')
        .directive('sourceChart', sourceChart);

    /** @ngInject */
    function sourceChart(SolrRequest) {
        var directive = {
            restrict: 'E',
            template: '<nvd3 options="vm.options" data="vm.chartdata"></nvd3>',
            scope: {
                data: '='
            },
            controller: ChartController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ChartController($scope, $filter, $timeout) {
            var jsonSources = JSON.parse('{                "table": "source",                "rows":                [                    {                        "source_id": 1,                        "source_link": "https://news.ycombinator.com/newest",                        "created": "2014-10-04 10:54:53",                        "source_description": "Y Combinator - Hacker News",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 3,                        "source_link": "https://lobste.rs/recent",                        "created": "2014-11-05 12:58:45",                        "source_description": "Lobsters",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 4,                        "source_link": "http://news.makerland.org/new/",                        "created": "2014-11-05 12:59:40",                        "source_description": "Makernews",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 5,                        "source_link": "http://www.reddit.com/r/BSD",                        "created": "2014-11-05 14:39:24",                        "source_description": "reddit - BSD",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 6,                        "source_link": "http://www.reddit.com/r/cableporn",                        "created": "2014-11-05 14:41:16",                        "source_description": "reddit - Cableporn",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 7,                        "source_link": "http://www.reddit.com/r/DataHoarder",                        "created": "2014-11-05 14:41:59",                        "source_description": "reddit - DataHoarder",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 8,                        "source_link": "http://www.reddit.com/r/devkit",                        "created": "2014-11-05 14:42:26",                        "source_description": "reddit - Devkit",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 9,                        "source_link": "http://www.reddit.com/r/ECE",                        "created": "2014-11-05 14:42:49",                        "source_description": "reddit - embeddedlinux",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 10,                        "source_link": "http://www.reddit.com/r/freebsd",                        "created": "2014-11-05 14:44:33",                        "source_description": "reddit - FreeBSD",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 11,                        "source_link": "http://www.reddit.com/r/haikuOS",                        "created": "2014-11-05 14:45:29",                        "source_description": "reddit - HaikuOS",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 12,                        "source_link": "http://www.reddit.com/r/homelab",                        "created": "2014-11-05 14:45:43",                        "source_description": "reddit - Homelab",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 13,                        "source_link": "http://www.reddit.com/r/kernel",                        "created": "2014-11-05 14:47:10",                        "source_description": "reddit - Kernel",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 14,                        "source_link": "http://www.reddit.com/r/linux",                        "created": "2014-11-05 14:47:26",                        "source_description": "reddit - Linux",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 15,                        "source_link": "http://www.reddit.com/r/linuxadmin",                        "created": "2014-11-05 14:47:43",                        "source_description": "reddit - Linuxadmin",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 16,                        "source_link": "http://www.reddit.com/r/linuxdev",                        "created": "2014-11-05 14:48:06",                        "source_description": "reddit - LinuxDev",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 17,                        "source_link": "http://www.reddit.com/r/linux_devices",                        "created": "2014-11-05 14:48:25",                        "source_description": "reddit - Linux Devices",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 18,                        "source_link": "http://www.reddit.com/r/NetBSD",                        "created": "2014-11-05 14:48:50",                        "source_description": "reddit - NetBSD",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 19,                        "source_link": "http://www.reddit.com/r/netsec",                        "created": "2014-11-05 14:49:10",                        "source_description": "reddit - NetSec",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 20,                        "source_link": "http://www.reddit.com/r/openbsd",                        "created": "2014-11-05 14:51:00",                        "source_description": "reddit - OpenBSD",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 21,                        "source_link": "http://www.reddit.com/r/opensourcehardware",                        "created": "2014-11-05 14:51:23",                        "source_description": "reddit - Opensource Hardware",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 22,                        "source_link": "http://www.reddit.com/r/openSUSE",                        "created": "2014-11-05 14:51:51",                        "source_description": "reddit - OpenSUSE",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 23,                        "source_link": "http://www.reddit.com/r/openwrt",                        "created": "2014-11-05 14:52:16",                        "source_description": "reddit - OpenWRT",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 24,                        "source_link": "http://www.reddit.com/r/osdev",                        "created": "2014-11-05 14:52:27",                        "source_description": "reddit - OS Dev",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 25,                        "source_link": "http://www.reddit.com/r/RTLSDR",                        "created": "2014-11-05 14:52:58",                        "source_description": "reddit - RTLSDR",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 26,                        "source_link": "http://www.reddit.com/r/sysadmin",                        "created": "2014-11-05 14:53:20",                        "source_description": "reddit - Sysadmin",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 27,                        "source_link": "http://www.reddit.com/r/systems",                        "created": "2014-11-05 14:53:37",                        "source_description": "reddit - Systems",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 28,                        "source_link": "http://www.reddit.com/r/unix",                        "created": "2014-11-05 14:53:53",                        "source_description": "reddit - Unix",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 29,                        "source_link": "http://www.reddit.com/r/usefulscripts",                        "created": "2014-11-05 14:54:07",                        "source_description": "reddit - Usefulscripts",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 30,                        "source_link": "http://www.reddit.com/r/REMath",                        "created": "2014-11-05 14:54:35",                        "source_description": "reddit - REMath",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 31,                        "source_link": "http://www.reddit.com/r/ReverseEngineering",                        "created": "2014-11-05 14:56:16",                        "source_description": "reddit - Reverse Engineering",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 32,                        "source_link": "http://www.reddit.com/r/lowlevel",                        "created": "2014-11-05 14:56:38",                        "source_description": "reddit - Lowlevel",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 33,                        "source_link": "http://www.reddit.com/r/vrd",                        "created": "2014-11-05 14:57:32",                        "source_description": "reddit - VRD",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 34,                        "source_link": "http://www.reddit.com/r/math",                        "created": "2014-11-05 14:57:54",                        "source_description": "reddit - Math",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 35,                        "source_link": "http://www.reddit.com/r/types",                        "created": "2014-11-05 14:58:23",                        "source_description": "reddit - Types",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 36,                        "source_link": "http://www.reddit.com/r/dependent_types",                        "created": "2014-11-05 14:58:39",                        "source_description": "reddit - Dependent Types",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 37,                        "source_link": "http://www.reddit.com/r/Coq",                        "created": "2014-11-05 14:59:08",                        "source_description": "reddit - Coq",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 38,                        "source_link": "http://www.reddit.com/r/haskell",                        "created": "2014-11-05 14:59:23",                        "source_description": "reddit - Haskell",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 39,                        "source_link": "http://www.reddit.com/r/ocaml",                        "created": "2014-11-05 14:59:46",                        "source_description": "reddit - Ocaml",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 40,                        "source_link": "http://www.reddit.com/r/crypto",                        "created": "2014-11-05 15:00:08",                        "source_description": "reddit - Crypto",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 41,                        "source_link": "http://www.reddit.com/r/fsharp",                        "created": "2014-11-05 15:00:24",                        "source_description": "reddit - FSharp",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 42,                        "source_link": "http://www.reddit.com/r/scala",                        "created": "2014-11-05 15:00:40",                        "source_description": "reddit - Scala",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 43,                        "source_link": "http://www.reddit.com/r/lisp",                        "created": "2014-11-05 15:00:51",                        "source_description": "reddit - Lisp",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 44,                        "source_link": "http://www.reddit.com/r/ProgrammingLanguages",                        "created": "2014-11-05 15:02:52",                        "source_description": "reddit - Programming Languages",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 45,                        "source_link": "http://www.reddit.com/r/dataisbeautiful",                        "created": "2014-11-05 15:03:30",                        "source_description": "reddit - Data is Beautiful",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 46,                        "source_link": "http://www.reddit.com/r/PhilosophyofMath",                        "created": "2014-11-05 15:03:52",                        "source_description": "reddit - Philospohy of Math",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 47,                        "source_link": "http://www.reddit.com/r/PhilosophyofScience",                        "created": "2014-11-05 15:04:23",                        "source_description": "reddit - Philosophy of Science",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 48,                        "source_link": "http://www.reddit.com/r/MachineLearning",                        "created": "2014-11-05 15:04:53",                        "source_description": "reddit - Machine Learning",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 49,                        "source_link": "http://www.reddit.com/r/IPython",                        "created": "2014-11-05 15:05:10",                        "source_description": "reddit - IPython",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 50,                        "source_link": "http://www.reddit.com/r/statistics",                        "created": "2014-11-05 15:05:24",                        "source_description": "reddit - Statistics",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 51,                        "source_link": "http://www.reddit.com/r/Design",                        "created": "2014-11-05 15:05:50",                        "source_description": "reddit - Design",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 52,                        "source_link": "http://www.reddit.com/r/webdev",                        "created": "2014-11-05 15:06:36",                        "source_description": "reddit - Webdev",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 53,                        "source_link": "http://www.reddit.com/r/web_design",                        "created": "2014-11-05 15:06:48",                        "source_description": "reddit - Webdesign",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 54,                        "source_link": "http://www.reddit.com/r/Frontend",                        "created": "2014-11-05 15:07:02",                        "source_description": "reddit - Frontend",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 55,                        "source_link": "http://www.reddit.com/r/duckduckgo",                        "created": "2014-11-05 15:07:34",                        "source_description": "reddit - DuckDuckGo",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 56,                        "source_link": "http://www.reddit.com/r/node",                        "created": "2014-11-05 15:07:53",                        "source_description": "reddit - NodeJS",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 57,                        "source_link": "http://www.reddit.com/r/angularjs",                        "created": "2014-11-05 15:09:01",                        "source_description": "reddit - Angular JS",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 58,                        "source_link": "http://www.reddit.com/r/sysor",                        "created": "2014-11-05 15:09:42",                        "source_description": "reddit - Sysor",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 59,                        "source_link": "http://www.reddit.com/r/optimization",                        "created": "2014-11-05 15:09:56",                        "source_description": "reddit - Optimization",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 60,                        "source_link": "http://www.reddit.com/r/algorithms",                        "created": "2014-11-05 15:10:14",                        "source_description": "reddit - Algorithms",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 61,                        "source_link": "http://www.reddit.com/r/BusinessIntelligence",                        "created": "2014-11-05 15:10:58",                        "source_description": "reddit - Business Intelligence",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 62,                        "source_link": "http://www.reddit.com/r/Database",                        "created": "2014-11-05 15:11:13",                        "source_description": "reddit - Database",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 63,                        "source_link": "http://www.reddit.com/r/datasets",                        "created": "2014-11-05 15:11:26",                        "source_description": "reddit - Datasets",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 64,                        "source_link": "http://www.reddit.com/r/datascience",                        "created": "2014-11-05 15:11:47",                        "source_description": "reddit - Data Science",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 65,                        "source_link": "http://www.reddit.com/r/opendata",                        "created": "2014-11-05 15:12:08",                        "source_description": "reddit - OpenData",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 66,                        "source_link": "http://www.reddit.com/r/analyzit",                        "created": "2014-11-05 15:12:27",                        "source_description": "reddit - Analyzit",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 67,                        "source_link": "http://www.reddit.com/r/semanticweb",                        "created": "2014-11-05 15:12:43",                        "source_description": "reddit - Semantic Web",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 68,                        "source_link": "http://www.reddit.com/r/visualization",                        "created": "2014-11-05 15:13:02",                        "source_description": "reddit - Visualization",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 69,                        "source_link": "http://www.reddit.com/r/analytics",                        "created": "2014-11-05 15:13:16",                        "source_description": "reddit - Analytics",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 70,                        "source_link": "http://www.reddit.com/r/programming",                        "created": "2014-11-05 15:18:03",                        "source_description": "reddit - Programming",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 71,                        "source_link": "http://www.reddit.com/r/Python",                        "created": "2014-11-05 15:18:32",                        "source_description": "reddit - Python",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 72,                        "source_link": "http://www.reddit.com/r/django",                        "created": "2014-11-05 15:18:45",                        "source_description": "reddit - Django",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 73,                        "source_link": "http://lesswrong.com/r/discussion",                        "created": "2014-11-05 15:20:16",                        "source_description": "Lesswrong Discussion",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 74,                        "source_link": "http://soylentnews.org/",                        "created": "2014-11-05 15:21:46",                        "source_description": "Soylent News",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 75,                        "source_link": "http://slashdot.org/",                        "created": "2014-11-05 15:23:57",                        "source_description": "Slashdot.org",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 76,                        "source_link": "http://www.reddit.com/r/coding",                        "created": "2014-11-05 15:25:25",                        "source_description": "reddit - Coding",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 77,                        "source_link": "http://digg.com/tag/technology",                        "created": "2014-11-05 15:28:30",                        "source_description": "digg - technology",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 78,                        "source_link": "http://coinspotting.com/newest",                        "created": "2014-11-05 15:30:05",                        "source_description": "Coinspotting - for Cryptocurrencies",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 79,                        "source_link": "http://www.datatau.com/newest",                        "created": "2014-11-05 15:30:28",                        "source_description": "DataTau - for Data Scientists",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 80,                        "source_link": "http://firespotting.com/newest",                        "created": "2014-11-05 15:30:49",                        "source_description": "Firespotting - for Ideas",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 81,                        "source_link": "http://www.medtechnologynews.com/newest",                        "created": "2014-11-05 15:32:08",                        "source_description": "Med Technology News - Hacker News for medical technology",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 82,                        "source_link": "http://inbound.org/",                        "created": "2014-11-05 15:34:29",                        "source_description": "Inbound - For Marketing",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 83,                        "source_link": "http://pullup.io/news",                        "created": "2014-11-05 15:35:34",                        "source_description": "Pullup.io - NodeJS related",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 84,                        "source_link": "http://lamernews.com/latest/0",                        "created": "2014-11-05 15:36:22",                        "source_description": "Lamernews",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 85,                        "source_link": "http://www.woodspotting.com/latest/0",                        "created": "2014-11-05 15:39:11",                        "source_description": "WoodSpotting ",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 86,                        "source_link": "http://www.reddit.com/r/Entrepreneur",                        "created": "2014-11-05 15:55:48",                        "source_description": "reddit - Entrepeneur",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 87,                        "source_link": "http://www.reddit.com/r/smallbusiness",                        "created": "2014-11-05 15:56:10",                        "source_description": "reddit - Smallbusiness",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 88,                        "source_link": "http://www.reddit.com/r/startups",                        "created": "2014-11-05 15:56:24",                        "source_description": "reddit - Startups",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 89,                        "source_link": "http://www.echojs.com/latest/0",                        "created": "2014-11-05 15:57:00",                        "source_description": "Echo JS - News for Javascript",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 91,                        "source_link": "https://usv.com/",                        "created": "2014-11-05 16:01:21",                        "source_description": "USV - Union Square Ventures",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 92,                        "source_link": "http://devmaster.net/",                        "created": "2014-11-05 16:05:55",                        "source_description": "Devmaster - Game Development News &amp; Links",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 93,                        "source_link": "http://www.dzone.com/links/queue.html",                        "created": "2014-11-05 16:09:03",                        "source_description": "Dzone - Smart Content For Tech Professionals",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 94,                        "source_link": "http://www.reddit.com/r/Bitcoin",                        "created": "2014-11-05 16:10:12",                        "source_description": "reddit - Bitcoin",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 95,                        "source_link": "http://www.reddit.com/r/Ingress",                        "created": "2014-11-21 19:58:47",                        "source_description": "reddit - Ingress",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 96,                        "source_link": "http://www.reddit.com/r/gamification",                        "created": "2014-11-21 20:03:54",                        "source_description": "reddit - Gamification",                        "source_active": 0,                        "source_rss": 0                    },                    {                        "source_id": 97,                        "source_link": "http://www.reddit.com/r/fintech",                        "created": "2015-05-30 07:22:23",                        "source_description": "reddit - Financial Technology",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 98,                        "source_link": "http://www.reddit.com/r/accounting",                        "created": "2015-05-30 07:40:49",                        "source_description": "reddit - Accounting",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 99,                        "source_link": "http://www.reddit.com/r/business",                        "created": "2015-05-30 07:43:31",                        "source_description": "reddit - Business",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 101,                        "source_link": "http://www.reddit.com/r/InternationalBusiness",                        "created": "2015-05-30 07:43:31",                        "source_description": "reddit - International Business",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 102,                        "source_link": "http://www.reddit.com/r/Insidernews",                        "created": "2015-05-30 07:43:31",                        "source_description": "reddit - Insidernews",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 103,                        "source_link": "http://www.reddit.com/r/IOT",                        "created": "2015-05-30 07:43:31",                        "source_description": "reddit - Internet of Things (IoT)",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 104,                        "source_link": "https://javascriptkicks.com",                        "created": "2015-08-01 08:12:58",                        "source_description": "JavaScript Kicks",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 105,                        "source_link": null,                        "created": "2016-02-13 02:12:54",                        "source_description": "Twitter Stream",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 106,                        "source_link": "http://www.reddit.com/r/worldnews",                        "created": "2016-02-13 05:03:42",                        "source_description": "reddit - World News",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 107,                        "source_link": null,                        "created": "2016-02-13 02:13:14",                        "source_description": "Securities and Exchange Commission (SEC) - Edgar filings",                        "source_active": 1,                        "source_rss": 0                    },                    {                        "source_id": 108,                        "source_link": "http://www.epcengineer.com/rss/news/category/1/projects",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - EPCEngineer - Projects",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 109,                        "source_link": "http://www.epcengineer.com/rss/news/category/2/finance-investment",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - EPCEngineer - Finance",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 110,                        "source_link": "http://www.epcengineer.com/rss/news/category/3/contract-awards",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - EPCEngineer - Contract Awards",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 111,                        "source_link": "http://www.epcengineer.com/rss/news/category/4/engineering-construction",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - EPCEngineer - Engineering Construction",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 112,                        "source_link": "http://www.epcengineer.com/rss/news/category/5/operations-maintenance",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - EPCEngineer - Operation Construction",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 113,                        "source_link": "http://www.epcengineer.com/rss/news/category/6/exploration-survey",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - EPCEngineer - Exploration Survey",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 114,                        "source_link": "http://www.epcengineer.com/rss/news/category/7/production",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - EPCEngineer - Production",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 115,                        "source_link": "http://feeds.feedburner.com/TechCrunch/",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - Techcrunch",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 116,                        "source_link": "http://feeds.feedburner.com/Makeuseof?format=xml",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - MakeUseOf",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 117,                        "source_link": "http://feeds.feedburner.com/giveawayoftheday/feed?format=xml",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - GiveAway of the Day",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 118,                        "source_link": "http://feeds.gawker.com/lifehacker/full",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - Lifehacker",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 119,                        "source_link": "http://feeds.feedburner.com/Mashable?format=xml",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - Mashable",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 120,                        "source_link": "http://feeds.feedburner.com/QuickOnlineTips?format=xml",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - Quick Online Tips",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 122,                        "source_link": "http://www.epcengineer.com/rss/news/category/8/legal-regulatory",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - EPCEngineer - Legal and Regulatory",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 123,                        "source_link": "http://www.epcengineer.com/rss/news/category/9/research-development",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - EPCEngineer - Research and Development",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 124,                        "source_link": "http://www.epcengineer.com/rss/news/oil-and-gas",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - EPCEngineer - Oil and Gas News",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 125,                        "source_link": "http://www.epcengineer.com/rss/news/mining-and-minerals",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - EPCEngineer - Mining and Minerals",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 126,                        "source_link": "http://www.epcengineer.com/rss/news/power-and-energy",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - EPCEngineer - Power and Energy",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 127,                        "source_link": "http://www.epcengineer.com/rss/news/building-and-infrastructure",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - EPCEngineer - Building and Infrastructure",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 129,                        "source_link": "http://feeds.reuters.com/reuters/businessNews?format=xml",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - Reuters Business News",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 130,                        "source_link": "http://feeds.reuters.com/reuters/companyNews?format=xml",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - Reuters Company News",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 131,                        "source_link": "http://feeds.reuters.com/reuters/scienceNews?format=xml",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - Reuters Science News",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 132,                        "source_link": "http://feeds.reuters.com/Reuters/worldNews?format=xml",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - Reuters World News",                        "source_active": 1,                        "source_rss": 1                    },                    {                        "source_id": 133,                        "source_link": "http://www.constructionweekonline.com/rssFeed/WebRssFeeds/TENDERS/",                        "created": "2016-03-28 15:39:03",                        "source_description": "RSS - Tenders - Construction Week Online",                        "source_active": 1,                        "source_rss": 1                    }                ]            }');
            var arrSourcesLabels = [];
            var arrSourcesLinks = [];
            angular.forEach(jsonSources.rows, function (value) {
                arrSourcesLabels[value.source_id] = value.source_description;
                if(value.source_link != null) {
                    arrSourcesLinks[value.source_id] = value.source_link.replace(/\/newest$|\/recent$|\/links\/queue\.html$/, '');
                }
            });
            var vm = this;

            vm.options = {
                chart: {
                    type: 'discreteBarChart',
                    height: 500,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 150,
                        left: 70
                    },
                    x: function (d) {
                        return d[0];
                    },
                    y: function (d) {
                        return d[1];
                    },
                    discretebar: {
                      dispatch: {
                          elementClick: function(e) {
                              var found = false;
                              angular.forEach(vm.data.keywords, function(value) {
                                  if(value.type.typeValue == 'source') {
                                      found = true;
                                      value.keyword = arrSourcesLinks[e.data[0]];
                                  }

                              });
                              if(!found) {
                                  vm.data.keywords.push({
                                      type: $filter("filter")(vm.data.keywordTypes, {typeValue: 'source'})[0],
                                      keyword: arrSourcesLinks[e.data[0]]
                                  });
                              }
                              //$scope.$apply();
                              vm.loadChart();
                          }
                      }
                    },
                    duration: 100,
                    xAxis: {

                        tickFormat: function(d) {
                          return arrSourcesLabels[d];
                        },
                        rotateLabels: -45,
                        axisLabel: 'Sources of the documents in Index'
                    },
                    yAxis: {
                        tickFormat: function (d) {
                            return d3.format('s')(d);
                        }
                    }
                },
                title: {
                    enable: true,
                    text: 'Sources Chart'
                },
                subtitle: {
                    enable: true,
                    text: 'Where are those links submitted? Or where were they cross-posted?',
                    css: {
                        'text-align': 'center',
                        'margin': '10px 13px 0px 7px',
                        'font-size': '80%'
                    }
                }
            };

            vm.chartdata = [{key: "Number of Documents per Source", values: []}];

            vm.loadChart = function () {

                var query1 = new SolrQuery();
                query1.setKeywords("*:*");
                query1.getImportancy().points = 0;
                query1.getImportancy().age = 0;
                query1.addFilterQuery("content_type:document");
                query1.setFilterQueryFromArray(vm.data.keywords);
                query1.addFacetTerms("source_sites", "source_site_ids_is", 10, 1);
                var solrReq_1 = new SolrRequest.Instance();
                solrReq_1.setQuery(query1);
                solrReq_1.loadNews().then(function () {

                    vm.chartdata[0].values = [];
                    if (solrReq_1.getFacets().count > 0) {
                        angular.forEach(solrReq_1.getFacets()["source_sites"]["buckets"], function (value) {
                            vm.chartdata[0].values.push([value.val, value.count]);

                        });
                        console.log(vm.chartdata);

                    }
                });
            };
            var loadChartTimeout;

            function loadChartDelayed() {
                if(loadChartTimeout !== undefined) {
                    $timeout.cancel(loadChartTimeout);
                }
                loadChartTimeout = $timeout(vm.loadChart, 550);
            }

            $scope.$watch("vm.data", loadChartDelayed, true);
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('newscombinatorKeywords')
        .directive('hoursPickupChart', hoursPickupChart);

    /** @ngInject */
    function hoursPickupChart(SolrRequest) {
        var directive = {
            restrict: 'E',
            template: '<nvd3 options="vm.options" data="vm.chartdata"></nvd3>',
            scope: {
                data: '='
            },
            controller: ChartController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ChartController($scope, $filter, $timeout) {

            var vm = this;

            vm.options = {
                chart: {
                    type: 'multiChart',
                    height: 500,
                    margin: {
                        top: 20,
                        right: 60,
                        bottom: 50,
                        left: 70
                    },
                    duration: 1000,
                    reduceXTicks: false,
                    useInteractiveGuideline: true,
                    bars1: {
                        stacked: true,
                        dispatch: {
                            elementClick: function(e) {
                                var found = false;
                                angular.forEach(vm.data.keywords, function(value) {
                                    if(value.type.typeValue == 'found_hours_is') {
                                        found = true;
                                        value.keyword = e.data.x;
                                    }

                                });
                                if(!found) {
                                    vm.data.keywords.push({
                                        type: $filter("filter")(vm.data.keywordTypes, {typeValue: 'found_hours_is'})[0],
                                        keyword: e.data.x
                                    });
                                }
                                //$scope.$apply();
                                vm.loadChart();
                            }
                        }
                    },
                    yAxis1: {
                        tickFormat: function (d) {
                            return d3.format('s')(d);
                        },
                        axisLabel: 'Number of Documents'
                    },
                    yAxis2: {
                        tickFormat: function (d) {
                            return d+"%";
                        },
                        axisLabel: 'Pickup Rate'
                    },
                    xAxis: {

                        axisLabel: 'Hours of the Day'
                    }
                },
                title: {
                    enable: true,
                    text: 'Hour of the day chart'
                },
                subtitle: {
                    enable: true,
                    text: 'This chart shows at which time of the day how many submitted links landed on the frontpage and which ones not. If documents are submitted twice and one time it reaches the frontpage and one time it will not make it there, it will be counted twice.',
                    css: {
                        'text-align': 'center',
                        'margin': '10px 13px 0px 7px',
                        'font-size': '80%'
                    }
                }
            };

            vm.chartdata = [{values: [], key: 'On Frontpage', yAxis:1, type:'bar'}, {values: [], key: 'Not On Frontpage', yAxis:1, type:'bar'}, {values: [], key: 'Pickup Rate', yAxis:2, type:'line'}];

            vm.loadChart = function () {

                var query1 = new SolrQuery();
                query1.setKeywords("*:*");
                query1.getImportancy().points = 0;
                query1.getImportancy().age = 0;
                query1.addFilterQuery("content_type:document");
                query1.setFilterQueryFromArray(vm.data.keywords);

                query1.addFacetTerms("hours_of_the_day", "found_hours_is", 24, 1, undefined, undefined, {index: "asc"});
                query1.addFacetTerms("frontpage", "on_frontpage", 2, 0, "hours_of_the_day", {blockParent: "content_type:sourceitem"});
                var solrReq_1 = new SolrRequest.Instance();
                solrReq_1.setQuery(query1);
                solrReq_1.loadNews().then(function () {

                    vm.chartdata[0].values = [];
                    vm.chartdata[1].values = [];
                    vm.chartdata[2].values = [];
                    if (solrReq_1.getFacets().count > 0) {
                        angular.forEach(solrReq_1.getFacets()["hours_of_the_day"]["buckets"], function (value) {
                            if (value.frontpage !== undefined) {
                                var on_frontpage = 0;
                                var not_on_frontpage = 0;

                                angular.forEach(value.frontpage.buckets, function (value_fp) {
                                    if (value_fp.val === true) {
                                        vm.chartdata[0].values.push({x :value.val, y:value_fp.count});
                                        on_frontpage = value_fp.count;
                                    } else {
                                        vm.chartdata[1].values.push({x :value.val, y:value_fp.count});
                                        not_on_frontpage = value_fp.count;
                                    }
                                });

                                vm.chartdata[2].values.push({x: value.val, y: Math.round((on_frontpage / (not_on_frontpage+on_frontpage))*100)});
                            } else {
                                vm.chartdata[0].values.push({x :value.val, y:0});
                                vm.chartdata[1].values.push({x :value.val, y:null});
                                vm.chartdata[2].values.push({x :value.val, y:null});
                            }
                        });

                    }
                });
            };
            var loadChartTimeout;

            function loadChartDelayed() {
                if(loadChartTimeout !== undefined) {
                    $timeout.cancel(loadChartTimeout);
                }
                loadChartTimeout = $timeout(vm.loadChart, 550);
            }

            $scope.$watch("vm.data", loadChartDelayed, true);

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('newscombinatorKeywords')
        .directive('hoursChart', hoursChart);

    /** @ngInject */
    function hoursChart(SolrRequest) {
        var directive = {
            restrict: 'E',
            template: '<nvd3 options="vm.options" data="vm.chartdata"></nvd3>',
            scope: {
                data: '='
            },
            controller: ChartController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ChartController($scope, $filter, $timeout) {

            var vm = this;

            vm.options = {
                chart: {
                    type: 'multiBarChart',
                    height: 450,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 50,
                        left: 70
                    },
                    x: function (d) {
                        return d[0];
                    },
                    y: function (d) {
                        return d[1];
                    },
                    multibar: {
                        dispatch: {
                            elementClick: function (e) {
                                vm.data.keywords.push({
                                    type: $filter("filter")(vm.data.keywordTypes, {typeValue: 'found_hours_is'})[0],
                                    keyword: e.data[0]
                                });
                                $scope.$apply();
                                vm.loadChart();
                            }

                        }
                    },
                    duration: 1000,
                    useInteractiveGuideline: true,
                    reduceXTicks: false,
                    yAxis: {
                        tickFormat: function (d) {
                            return d3.format('s')(d);
                        },
                        axisLabel: '#Documents'
                    },
                    xAxis: {
                        axisLabel: 'Hours of the Day'
                    }
                },
                title: {
                    enable: true,
                    text: 'Hour of the day chart'
                },
                subtitle: {
                    enable: true,
                    text: 'This chart shows at which time of the day how many documents landed on the frontpage and which ones not.',
                    css: {
                        'text-align': 'center',
                        'margin': '10px 13px 0px 7px',
                        'font-size': '80%'
                    }
                }
            };

            vm.chartdata = [{values: [], key: 'On Frontpage'}, {values: [], key: 'Not On Frontpage'}];

            vm.loadChart = function () {

                var query1 = new SolrQuery();
                query1.setKeywords("*:*");
                query1.getImportancy().points = 0;
                query1.getImportancy().age = 0;
                query1.addFilterQuery("content_type:document");
                query1.setFilterQueryFromArray(vm.data.keywords);

                query1.addFacetTerms("hours_of_the_day", "found_hours_is", 24, 1, undefined, undefined, {index: "asc"});
                query1.addFacetTerms("frontpage", "on_frontpage", 2, 0, "hours_of_the_day", {blockParent: "content_type:sourceitem"});
                var solrReq_1 = new SolrRequest.Instance();
                solrReq_1.setQuery(query1);
                solrReq_1.loadNews().then(function () {

                    vm.chartdata[0].values = [];
                    vm.chartdata[1].values = [];
                    if (solrReq_1.getFacets().count > 0) {
                        angular.forEach(solrReq_1.getFacets()["hours_of_the_day"]["buckets"], function (value) {
                            if (value.frontpage !== undefined) {
                                angular.forEach(value.frontpage.buckets, function (value_fp) {
                                    if (value_fp.val === true) {
                                        vm.chartdata[0].values.push([value.val, value_fp.count]);
                                    } else {
                                        vm.chartdata[1].values.push([value.val, value_fp.count]);
                                    }
                                });
                            } else {
                                vm.chartdata[0].values.push([value.val, null]);
                                vm.chartdata[1].values.push([value.val, null]);
                            }
                        });

                    }
                });
            };
            var loadChartTimeout;

            function loadChartDelayed() {
                if(loadChartTimeout !== undefined) {
                    $timeout.cancel(loadChartTimeout);
                }
                loadChartTimeout = $timeout(vm.loadChart, 550);
            }

            $scope.$watch("vm.data", loadChartDelayed, true);

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('newscombinatorKeywords')
        .directive('documentsPerPointsChart',documentsPerPointsChart);

    /** @ngInject */
    function documentsPerPointsChart(SolrRequest) {
        var directive = {
            restrict: 'E',
            template: '<nvd3 options="vm.options" data="vm.chartdata"></nvd3>',
            scope: {
                data: '='
            },
            controller: ChartController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ChartController($scope, $filter, $timeout) {

            var vm = this;

            vm.options = {
                chart: {
                    lines: {
                        dispatch: {
                            elementClick: function (e) {
                                var found = false;
                                angular.forEach(vm.data.keywords, function(value) {
                                    if(value.type.typeValue == 'minPoints') {
                                        found = true;
                                        value.keyword = e[0].point.x;
                                    }

                                });
                                if(!found) {
                                    vm.data.keywords.push({
                                        type: $filter("filter")(vm.data.keywordTypes, {typeValue: 'minPoints'})[0],
                                        keyword: e[0].point.x
                                    });
                                }
                                //$scope.$apply();
                                vm.loadChart();
                            }
                        }
                    },
                    interactiveLayer: {
                        tooltip: {
                            contentGenerator: function (d) {
                                var lowerNumber = (d.value) + " to " + (d.value + 25);

                                return '<h3>Number of Documents</h3>' +
                                    '<br />' + d.series[0].value + ' Links with ' + (lowerNumber) + ' ' + d.series[0].key +
                                    '<br />' + d.series[1].value + ' Links with ' + (lowerNumber) + ' ' + d.series[1].key;
                            }
                        }
                    },

                    type: 'lineChart',
                    height: 500,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 80,
                        left: 70
                    },
                    x: function (d) {
                        return d.x;
                    },
                    xAxis: {
                        axisLabel: '#Documents with #Points/#Comments across Aggregators (Ycombinator, Reddit,...)',
                        rotateLabels: -45
                    },
                    y: function (d) {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    duration: 1000,
                    yAxis: {
                        tickFormat: function (d) {
                            return d3.format('s')(d);
                        }
                    }
                },
                title: {
                    enable: true,
                    text: 'Number of Documents per Points/Comments'
                },
                subtitle: {
                    enable: true,
                    text: 'This shows the number of documents that received a certain number of points (upvotes) or comments. It is in 25 increments (0-24, 25-49,...)',
                    css: {
                        'text-align': 'center',
                        'margin': '10px 13px 0px 7px',
                        'font-size': '80%'
                    }
                }
            };

            vm.chartdata = [{values: [], key: 'Points'}, {values: [], key: 'Comments'}];

            vm.loadChart = function () {

                var query1 = new SolrQuery();
                query1.setKeywords("*:*");
                query1.getImportancy().points = 0;
                query1.getImportancy().age = 0;
                query1.addFilterQuery("content_type:document");
                query1.setFilterQueryFromArray(vm.data.keywords);
                query1.addFacetRange("points", "num_total_points", 0, 500, 25, undefined, 0);
                query1.addFacetRange("comments", "num_total_comments", 0, 500, 25, undefined, 0);
                var solrReq_1 = new SolrRequest.Instance();
                solrReq_1.setQuery(query1);
                solrReq_1.loadNews().then(function () {

                    vm.chartdata[0].values = [];
                    vm.chartdata[1].values = [];
                    if (solrReq_1.getFacets().count > 0) {
                        angular.forEach(solrReq_1.getFacets()["points"]["buckets"], function (value) {
                            vm.chartdata[0].values.push({x: value.val, y: value.count});
                        });
                        angular.forEach(solrReq_1.getFacets()["comments"]["buckets"], function (value) {
                            vm.chartdata[1].values.push({x: value.val, y: value.count});
                        });

                    }
                });
            };
            var loadChartTimeout;

            function loadChartDelayed() {
                if(loadChartTimeout !== undefined) {
                    $timeout.cancel(loadChartTimeout);
                }
                loadChartTimeout = $timeout(vm.loadChart, 550);
            }

            $scope.$watch("vm.data", loadChartDelayed, true);

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('newscombinatorKeywords')
        .directive('documentsOnFrontpageChart',documentsOnFrontpageChart);

    /** @ngInject */
    function documentsOnFrontpageChart(SolrRequest) {
        var directive = {
            restrict: 'E',
            template: '<nvd3 options="vm.options" data="vm.chartdata"></nvd3>',
            scope: {
                data: '='
            },
            controller: ChartController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ChartController($scope, $filter, $timeout) {

            var vm = this;

            vm.options = {
                chart: {
                    type: 'stackedAreaChart',
                    height: 500,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 30,
                        left: 70
                    },
                    x: function (d) {
                        return d[0];
                    },
                    y: function (d) {
                        return d[1];
                    },
                    duration: 1000,
                    useInteractiveGuideline: true,
                    yAxis: {
                        tickFormat: function (d) {
                            return d3.format('s')(d);
                        }
                    }
                },
                title: {
                    enable: true,
                    text: 'Number of Documents on Frontpage'
                },
                subtitle: {
                    enable: true,
                    text: 'This Chart shows the number of Documents which landed on the frontpage vs. the number of documents which never made it there.',
                    css: {
                        'text-align': 'center',
                        'margin': '10px 13px 0px 7px',
                        'font-size': '80%'
                    }
                }
            };

            vm.chartdata =  [{values: [], key: 'On Frontpage'}, {values: [], key: 'Not On Frontpage'}];

            vm.loadChart = function () {

                var query1 = new SolrQuery();
                query1.setKeywords("*:*");
                query1.getImportancy().points = 0;
                query1.getImportancy().age = 0;
                query1.addFilterQuery("content_type:document");
                query1.setFilterQueryFromArray(vm.data.keywords);
                query1.addFacetRange("points", "num_total_points", 0, 500, 25, undefined, 0);
                query1.addFacetTerms("frontpage", "on_frontpage", 2, 0, "points", {blockParent: "content_type:sourceitem"});
                var solrReq_1 = new SolrRequest.Instance();
                solrReq_1.setQuery(query1);
                solrReq_1.loadNews().then(function () {

                    vm.chartdata[0].values = [];
                    vm.chartdata[1].values = [];
                    if (solrReq_1.getFacets().count > 0) {
                        angular.forEach(solrReq_1.getFacets()["points"]["buckets"], function (value) {
                            if (value.frontpage !== undefined) {
                                angular.forEach(value.frontpage.buckets, function (value_fp) {
                                    if (value_fp.val === true) {
                                        vm.chartdata[0].values.push([value.val, value_fp.count]);
                                    } else {

                                        vm.chartdata[1].values.push([value.val, value_fp.count]);
                                    }
                                });
                            } else {
                                vm.chartdata[0].values.push([value.val, null]);
                                vm.chartdata[1].values.push([value.val, null]);
                            }
                        });

                    }
                });
            };
            var loadChartTimeout;

            function loadChartDelayed() {
                if(loadChartTimeout !== undefined) {
                    $timeout.cancel(loadChartTimeout);
                }
                loadChartTimeout = $timeout(vm.loadChart, 550);
            }

            $scope.$watch("vm.data", loadChartDelayed, true);

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('newscombinatorKeywords')
        .directive('dateChart',dateChart);

    /** @ngInject */
    function dateChart(SolrRequest) {
        var directive = {
            restrict: 'E',
            template: '<nvd3 options="vm.options" data="vm.chartdata"></nvd3>',
            scope: {
                data: '='
            },
            controller: ChartController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ChartController($scope, $filter, $timeout) {

            var vm = this;

            vm.options = {
                chart: {
                    type: 'multiBarChart',
                    height: 500,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 100,
                        left: 70
                    },
                    x: function (d) {
                        return d[0];
                    },
                    y: function (d) {
                        return d[1];
                    },
                    multibar: {
                      dispatch: {
                          elementClick: function(e){
                              var found = false;
                              angular.forEach(vm.data.keywords, function(value) {
                                  if(value.date !== undefined && value.type.typeValue == 'startDate' && value.date instanceof Date) {
                                      found = true;
                                      value.date = e.data[0];
                                  }

                              });
                              if(!found) {
                                  vm.data.keywords.push({
                                      type: $filter("filter")(vm.data.keywordTypes, {typeValue: 'startDate'})[0],
                                      date: e.data[0]
                                  });
                              }
                              $scope.$apply();
                              vm.loadChart();
                          }
                      }
                    },
                    useVoronoi: false,
                    clipEdge: false,
                    duration: 1000,
                    useInteractiveGuideline: true,
                    xAxis: {
                        expanded: true,
                        showMaxMin: true,

                        rotateLabels: -45,
                        tickFormat: function (date) {
                            return "From "+d3.time.format('%b %d, %Y')(new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()));
                        }

                    },
                    yAxis: {
                        tickFormat: function (d) {
                            return d3.format('s')(d);
                        },
                        axisLabel: 'Number of Documents'
                    }
                },
                title: {
                    enable: true,
                    text: 'Date Chart'
                },
                subtitle: {
                    enable: true,
                    text: 'How many submitted links landed on the frontpage between two specific dates? Click in the chart to change the start-date.',
                    css: {
                        'text-align': 'center',
                        'margin': '10px 13px 0px 7px',
                        'font-size': '80%'
                    }
                }
            };

            vm.chartdata = [{values: [], key: 'On Frontpage'}, {values: [], key: 'Not On Frontpage'}];

            vm.loadChart = function () {

                var query1 = new SolrQuery();
                query1.setKeywords("*:*");
                query1.getImportancy().points = 0;
                query1.getImportancy().age = 0;
                query1.addFilterQuery("content_type:document");
                query1.setFilterQueryFromArray(vm.data.keywords);
                var startDate = '2015-01-01T00:00:00Z';
                var endDate = new Date().toISOString();
                angular.forEach(vm.data.keywords, function(value) {
                    if(value.type.typeValue == 'startDate' && value.date instanceof Date) {
                        startDate = value.date.toISOString();
                    }
                    if(value.type.typeValue == 'endDate'  && value.date instanceof Date) {
                        endDate = value.date.toISOString();
                    }
                });

                query1.addFacetRange("date", "created_at", startDate, endDate, "+1MONTH", undefined, 0);
                query1.addFacetTerms("frontpage", "on_frontpage", 2, 0, "date", {blockParent: "content_type:sourceitem"});
                var solrReq_1 = new SolrRequest.Instance();
                solrReq_1.setQuery(query1);
                solrReq_1.loadNews().then(function () {

                    vm.chartdata[0].values = [];
                    vm.chartdata[1].values = [];
                    if (solrReq_1.getFacets().count > 0) {
                        angular.forEach(solrReq_1.getFacets()["date"]["buckets"], function (value) {
                            if (value.frontpage !== undefined) {
                                angular.forEach(value.frontpage.buckets, function (value_fp) {
                                    if (value_fp.val === true) {
                                        vm.chartdata[0].values.push([new Date(value.val), value_fp.count]);
                                    } else {
                                        vm.chartdata[1].values.push([new Date(value.val), value_fp.count]);
                                    }
                                });
                            } else {
                                vm.chartdata[0].values.push([new Date(value.val), null]);
                                vm.chartdata[1].values.push([new Date(value.val), null]);
                            }
                        });

                    }
                });
            };

            var loadChartTimeout;

            function loadChartDelayed() {
                if(loadChartTimeout !== undefined) {
                    $timeout.cancel(loadChartTimeout);
                }
                loadChartTimeout = $timeout(vm.loadChart, 550);
            }

            $scope.$watch("vm.data", loadChartDelayed, true);
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('newscombinatorKeywords')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($filter) {
        var vm = this;

        vm.keywords = [];

        vm.keywordTypes = [
            {typeValue: "general", typeName: "Any Document-Field", prefix: "", postfix: "", type: "text"},
            {typeValue: "notGeneral", typeName: "Exclude Keyword", prefix: "-(", postfix: ")", type: "text"},
            {typeValue: "linkTitle", typeName: "Link Title", prefix: "title_link:", postfix: "", type: "text"},
            {typeValue: "notLinkTitle", typeName: "Exclude Link Title", prefix: "-title_link:", postfix: "", type: "text"},
            {typeValue: "language", typeName: "Language (e.g. en)", prefix: "language:", postfix: "", type: "text"},
            {
                typeValue: "found_weekdays_ss",
                typeName: "Day of the Week (e.g. Sunday)",
                prefix: "found_weekdays_ss:",
                postfix: "",
                type: "select",
                values: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
            }, {
                typeValue: "not_found_weekdays_ss",
                typeName: "NOT at that Day of the Week",
                prefix: "-found_weekdays_ss:",
                postfix: "",
                type: "select",
                values: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
            },
            {
                typeValue: "found_hours_is",
                typeName: "Hour of the Day (e.g. '14' for 2pm)",
                prefix: "found_hours_is:",
                postfix: "",
                type: "select",
                values: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
            },
            {typeValue: "url", typeName: "Url", prefix: "url:", postfix: "", type: "text"},
            {
                typeValue: "source",
                typeName: "Source-Portal (e.g. reddit.com)",
                prefix: 'source_sites_ss:*',
                postfix: '*',
                type: "text",
                values: ["ycombinator.com", "reddit.com", "coinspotting.com", "firespotting.com", "sec.gov", "lobste.rs", "makerland.org", "slashdot.org", "soylendnews.org"]
            },
            {
                typeValue: "notSource",
                typeName: "Exclude Source-Portal",
                prefix: '-source_sites_ss:*',
                postfix: '*',
                type: "text"
            },
            {
                typeValue: "minPoints",
                typeName: "Min Upvotes",
                prefix: "num_total_points:[",
                postfix: " TO *]",
                type: "slider",
                step: 5,
                min: 0,
                max: 1000
            },
            {
                typeValue: "maxPoints",
                typeName: "Max Upvotes",
                prefix: "num_total_points:[* TO ",
                postfix: "]",
                type: "slider",
                step: 5,
                min: 0,
                max: 1000
            },
            {
                typeValue: "startDate",
                typeName: "Start Date",
                prefix: "created_at:[",
                postfix: " TO *]",
                type: "datepicker"
            },
            {
                typeValue: "endDate",
                typeName: "End Date",
                prefix: "created_at:[* TO ",
                postfix: " ]",
                type: "datepicker"
            }

        ];
        vm.directivedata = {
            keywords: vm.keywords,
            keywordTypes: vm.keywordTypes
        };

        vm.examplePickupRate = function () {

            vm.keywords.push({
                type: $filter("filter")(vm.keywordTypes, {typeValue: 'source'})[0],
                keyword: "https://news.ycombinator.com"
            });
            vm.keywords.push({
                type: $filter("filter")(vm.keywordTypes, {typeValue: 'linkTitle'})[0],
                keyword: "Show HN"
            });
            vm.keywords.push({
                type: $filter("filter")(vm.keywordTypes, {typeValue: 'startDate'})[0],
                date: new Date(2016,2,1)
            });

        };


        vm.addKeyword = function () {
            vm.keywords.push({type: vm.keywordTypes[0], keyword: ""});
        };


    }
})();

(function() {
  'use strict';

  angular
    .module('newscombinatorKeywords')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('newscombinatorKeywords')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('newscombinatorKeywords')
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('newscombinatorKeywords')
    .config(config);

  /** @ngInject */
  function config($logProvider, $mdThemingProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    $mdThemingProvider.theme('default');
  }

})();

angular.module("newscombinatorKeywords").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div layout=\"column\"><header><acme-navbar></acme-navbar></header><div layout=\"column\" layout-padding=\"\"><div layout=\"row\"><div flex-offset=\"25\" flex=\"50\"><h3>Introduction</h3><p>The tool below shows different statistics about all the indexed links from <a href=\"http://www.newscombinator.com\">The Newscombinator</a>. We are indexing in realtime whatever comes in from ycombinator, reddit, inbound, etc. Times are in UTC.<br><br>What is the tool useful for? <button ng-click=\"main.examplePickupRate()\">Click here for example</button>, when you want to know the best pickup rate for a submission on YC. Or run any other arbitrary statistics with submitted links.<br><br>Refine your search by clicking into the charts directly, or <a href=\"https://github.com/tomw1808/newscombinator-stats\" target=\"_blank\">clone and hack this.</a><br><br><br><br><br></p></div></div><form ng-submit=\"main.loadChart();\" flex=\"\"><div layout=\"column\"><div layout=\"row\" layout-fill=\"\" layout-align=\"center center\" ng-repeat=\"keywordObj in main.keywords\"><md-button type=\"button\" class=\"md-icon-button md-primary\" ng-click=\"main.keywords.splice($index,1); main.loadChart();\"><md-icon>clear</md-icon></md-button><md-input-container flex=\"20\"><label>Type</label><md-select ng-model=\"keywordObj.type\"><md-option ng-value=\"type\" ng-repeat=\"type in main.keywordTypes\">{{type.typeName}}</md-option></md-select></md-input-container><md-input-container flex=\"\" ng-show=\"keywordObj.type.type == \'select\'\"><label>Select a Value</label><md-select ng-model=\"keywordObj.keyword\"><md-option ng-repeat=\"value in keywordObj.type.values\" value=\"{{value}}\">{{value}}</md-option></md-select></md-input-container><md-input-container flex=\"\" ng-show=\"keywordObj.type.type == \'text\'\"><label>One Keyword at a Time (e.g. *google.com* or Elon Musk)</label> <input name=\"url\" ng-model=\"keywordObj.keyword\"></md-input-container><md-input-container flex=\"\" ng-show=\"keywordObj.type.type == \'datepicker\'\"><div flex=\"\" layout=\"\" layout-align=\"end center\"><span class=\"md-body-1\">Choose a Date</span></div><md-datepicker ng-model=\"keywordObj.date\" md-placeholder=\"Choose a Date\" aria-label=\"Choose a Date\"></md-datepicker></md-input-container><div flex=\"\" ng-show=\"keywordObj.type.type == \'slider\'\" layout-padding=\"50 0\" layout=\"\" layout-align=\"center center\"><md-slider aria-label=\"{{type.typeName}}\" flex=\"\" md-discrete=\"\" ng-model=\"keywordObj.keyword\" step=\"{{keywordObj.type.step}}\" min=\"{{keywordObj.type.min}}\" max=\"{{keywordObj.type.max}}\" ng-change=\"main.loadChart()\"></md-slider></div></div><div layout=\"row\" layout-fill=\"\" layout-wrap=\"\"><div layout=\"row\" flex=\"\"><md-button type=\"button\" class=\"md-primary md-raised\" ng-click=\"main.addKeyword();\" flex=\"\"><md-icon>add</md-icon>Add Search Criteria.</md-button></div></div></div></form><div layout=\"row\" layout-padding=\"\"><date-chart flex=\"\" data=\"main.directivedata\"></date-chart><source-chart flex=\"\" data=\"main.directivedata\"></source-chart></div><div layout=\"row\" layout-padding=\"\"><weekday-chart flex=\"\" data=\"main.directivedata\"></weekday-chart><hours-pickup-chart flex=\"\" data=\"main.directivedata\"></hours-pickup-chart></div><div layout=\"row\" layout-padding=\"\"><documents-per-points-chart flex=\"\" data=\"main.directivedata\"></documents-per-points-chart><documents-on-frontpage-chart flex=\"\" data=\"main.directivedata\"></documents-on-frontpage-chart></div><div layout=\"column\" layout-padding=\"\" layout-margin=\"\"><keywords-table flex=\"\" data=\"main.directivedata\"></keywords-table></div></div></div>");
$templateCache.put("app/components/keywordstable/keywordstable.html","<div layout=\"column\"><div layout=\"row\"><div flex-offset=\"25\" flex=\"50\"><h2>Keywords</h2><p>It shows keywords from documents which made it to the frontpage vs which never made it to the frontpage. Sometimes documents are posted several times and only one submission is making it to the frontpage, which eventually lead to duplicated keywords in this column and on the right side..</p></div></div><div layout=\"row\"><div flex=\"\" layout=\"column\"><h3>Top Keywords which made it to the Frontpage</h3><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><md-card ng-repeat=\"result in vm.keywordsdata\" ng-hide=\"vm.loading\"><md-card-content><div layout=\"row\"><nvd3 options=\"vm.chartoptions\" data=\"result.chartdata\"></nvd3><div layout=\"column\"><strong><a ng-click=\"vm.addKeyword(result.keyword.val);\" href=\"\">{{result.keyword.val}}</a></strong><p>{{result.keyword.count}} times in total<br>{{result.chartdata[0].y}} times {{result.chartdata[0].key}}<br>{{result.chartdata[1].y}} times {{result.chartdata[1].key}}</p></div></div></md-card-content></md-card></div><div flex=\"\" layout=\"column\"><h3>Keywords from documents not on the Frontpage</h3><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><md-card ng-repeat=\"result in vm.keywordsdata_non_fp\" ng-hide=\"vm.loading\"><md-card-content><div layout=\"row\"><nvd3 options=\"vm.chartoptions\" data=\"result.chartdata\"></nvd3><div layout=\"column\"><strong><a ng-click=\"vm.addKeyword(result.keyword.val);\" href=\"\">{{result.keyword.val}}</a></strong><p>{{result.keyword.count}} times in total<br>{{result.chartdata[0].y}} times {{result.chartdata[0].key}}<br>{{result.chartdata[1].y}} times {{result.chartdata[1].key}}</p></div></div></md-card-content></md-card></div></div></div><div layout=\"column\"><h2>Highest Voted Search Results</h2><p>It shows the documents which receied the most points across different portals. For example, a cross post on Reddit and Ycombinator with 50 points (upvotes) each, will result in a total of 100 points here.</p><div layout=\"row\"><div flex=\"50\" layout=\"column\"><h3>Highest Voted Documents on Frontpage</h3><md-card ng-repeat=\"result in vm.topResults\" ng-hide=\"vm.loading\"><md-card-content><h4>{{result.title_link}}</h4><p><a href=\"{{result.url}}\" target=\"_blank\">{{result.url}}</a></p><p>{{result.content_short}}</p></md-card-content><md-card-footer><small>Found: {{result.created_at | date:\'short\'}} &bull;<md-icon>arrow_drop_up</md-icon>{{result.num_total_points}} &bull;<md-icon>forum</md-icon>{{result.num_total_comments}}</small></md-card-footer></md-card><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear></div><div flex=\"50\" layout=\"column\"><h3>Highest Voted Documents never on Frontpage</h3><md-card ng-repeat=\"result in vm.topResults_non_fp\" ng-hide=\"vm.loading\"><md-card-content><h4>{{result.title_link}}</h4><p><a href=\"{{result.url}}\" target=\"_blank\">{{result.url}}</a></p><p>{{result.content_short}}</p></md-card-content><md-card-footer><small>Found: {{result.created_at | date:\'short\'}} &bull;<md-icon>arrow_drop_up</md-icon>{{result.num_total_points}} &bull;<md-icon>forum</md-icon>{{result.num_total_comments}}</small></md-card-footer></md-card><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar layout=\"row\" layout-align=\"center center\"><md-button href=\"https://www.newscombinator.com\">Newscombinator Keywords</md-button></md-toolbar>");}]);